import swiperWidget from '@commonWidgets/slider.js';
import faigroundsCardsWidget from '@fairgroundsWidgets/cardWidget.js';
import seoWidget from '@commonWidgets/seo.js';
import fairgroundsEventFeed from '@fairgroundsWidgets/eventFeed.js';

const isFairgroundsHome = window.location.pathname === '/';

export default function () {
  if (isFairgroundsHome) {
    $(document).ready(function () {
      swiperWidget('fairgroundsSwiperWidget', fairgroundsSwiperWidgetOpts);
      faigroundsCardsWidget();
      seoWidget('fairgroundsSeo', fairgroundsSeoOpts);
      fairgroundsEventFeed();
    });
  }
}
